module.exports = __webpack_public_path__ + "static/media/icon-ellipsis.b539ba33.svg";